__webpack_require__.p = "/vuthy-portfolio/";